<template>
  <div class="c-national-hospital-netwrk">
    <div class="promote">
      <div class="checking-service">
        <p class="checking-service__title">擴大全國性追蹤檢查服務計畫：</p>
        <p class="checking-service__content">
          與院方以鼓勵、回饋等方式合作，採醫院主動、家屬自動與轉介它院模式推廣該院早產兒追蹤檢查工作。
        </p>
      </div>

      <div class="promote-arrow">
        <div class="promote-arrow__box">
          <p class="promote-arrow__box__text">推廣</p>
        </div>
      </div>
      <div class="tracking-team">
        <p class="tracking-team__title">早產兒基金會極低體重早產兒追蹤檢查小組：</p>
        <p class="tracking-team__content">
          由早產兒基金會與院方合作，致力於協助該院每一位出生體重≤1500公克或出生週數≤29週之新生兒，進行為期兩年以上完整追蹤檢查服務。
        </p>
      </div>
    </div>

    <div class="hospital-distribute">
      <div class="taiwan">
        <img class="taiwan__img" src="@/assets/img/services/img_taiwan.svg" />
      </div>

      <div class="unit-wrap">
        <p class="unit-area-title">北部：</p>
        <div class="unit unit--north">
          <div class="unit__collaborate">
            <p class="unit__collaborate__title">擴大追蹤院區</p>
            <div class="unit__collaborate__list">
              <ul class="collaborate-list">
                <li class="collaborate-list__item" v-for="d of north.collaborate1" :key="d">◎{{ d }}</li>
              </ul>
              <ul class="collaborate-list">
                <li class="collaborate-list__item" v-for="d of north.collaborate2" :key="d">◎{{ d }}</li>
              </ul>
            </div>
          </div>
          <div class="arrow">
            <img src="@/assets/img/services/arrow.png" alt="" />
          </div>
          <div class="unit__promote extend">
            <p class="unit__promote__title">核心追蹤院區</p>
            <div class="unit__promote__list">
              <ul class="promote-list">
                <li class="promote-list__item" v-for="d of north.promote1" :key="d">◎{{ d }}</li>
              </ul>
              <ul class="promote-list">
                <li class="promote-list__item" v-for="d of north.promote2" :key="d">◎{{ d }}</li>
              </ul>
            </div>
          </div>
        </div>
        <p class="unit-area-title unit-area-title--margin-top">中部：</p>
        <div class="unit unit--middle">
          <div class="unit__collaborate">
            <p class="unit__collaborate__title">擴大追蹤院區</p>
            <div class="unit__collaborate__list">
              <ul class="collaborate-list">
                <li class="collaborate-list__item" v-for="d of middle.collaborate1" :key="d">◎{{ d }}</li>
              </ul>

              <ul class="collaborate-list">
                <li class="collaborate-list__item" v-for="d of middle.collaborate2" :key="d">◎{{ d }}</li>
              </ul>
            </div>
          </div>
          <div class="arrow">
            <img src="@/assets/img/services/arrow.png" alt="" />
          </div>
          <div class="unit__promote">
            <p class="unit__promote__title">核心追蹤院區</p>
            <div class="unit__promote__list">
              <ul class="promote-list">
                <li class="promote-list__item" v-for="d of middle.promote" :key="d">◎{{ d }}</li>
              </ul>
            </div>
          </div>
        </div>

        <p class="unit-area-title unit-area-title--margin-top">南部：</p>
        <div class="unit unit--south">
          <div class="unit__collaborate unit__collaborate--pc">
            <p class="unit__collaborate__title">擴大追蹤院區</p>
            <div class="unit__collaborate__list">
              <ul class="collaborate-list">
                <li class="collaborate-list__item collaborate-list__item--pc" v-for="d of south.collaborate" :key="d">
                  ◎{{ d }}
                </li>
              </ul>
            </div>
          </div>
          <div class="arrow">
            <img src="@/assets/img/services/arrow.png" alt="" />
          </div>
          <div class="unit__promote">
            <p class="unit__promote__title">核心追蹤院區</p>
            <div class="unit__promote__list">
              <ul class="promote-list">
                <li class="promote-list__item" v-for="d of south.promote" :key="d">◎{{ d }}</li>
              </ul>
            </div>
          </div>
        </div>

        <p class="unit-area-title unit-area-title--margin-top">東部：</p>
        <div class="unit unit--east">
          <!-- <div class="unit__promote">
            <p class="unit__promote__title">核心追蹤院區</p>
            <div class="unit__promote__list">
              <ul class="promote-list">
                <li class="promote-list__item" v-for="d of east.promote" :key="d">◎{{ d }}</li>
              </ul>
            </div>
          </div> -->

          <div class="unit__collaborate unit__collaborate--pc unit__collaborate--no-margin">
            <p class="unit__collaborate__title">擴大追蹤院區</p>
            <div class="unit__collaborate__list">
              <ul class="collaborate-list">
                <li class="collaborate-list__item collaborate-list__item--pc" v-for="d of east.collaborate" :key="d">
                  ◎{{ d }}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'NationalHospitalNetwrok',
  setup() {
    const north = {
      promote1: [
        '臺大附醫',
        '婦幼醫院',
        '國泰總院',
        '永和耕莘',
        '北醫附醫',
        '亞東醫院',
        '新光醫院',
        '台北榮總',
        '台北長庚',
        '三總醫院',
      ],
      promote2: ['台北馬偕', '新竹馬偕', '林口長庚'],
      collaborate1: [
        '羅東博愛',
        '羅東聖母',
        '陽大附醫',
        '部立基隆醫院',
        '淡水馬偕',
        '汐止國泰',
        '土城醫院',
        '臺安醫院',
        '市立仁愛',
        '宏恩醫院',

      ],
      collaborate2: [

        '部立雙和',
        '新店耕莘',
        '萬芳醫院',
        '台北慈濟',
        '恩主公醫院',
        '輔大附醫',
        '國軍桃園',
        '東元醫院',
        '新竹臺大',

      ],

      // collaborate1: [
      //   '部立基隆醫院',
      //   '淡水馬偕',
      //   '汐止國泰',
      //   '土城醫院',
      //   '臺安醫院',
      //   '市立仁愛',
      //   '宏恩醫院',
      //   '部立雙和',
      //   '新店耕莘',
      // ],
      // collaborate2: [
      //   '萬芳醫院',
      //   '台北慈濟',
      //   '恩主公醫院',
      //   '輔大附醫',
      //   '國軍桃園',
      //   '東元醫院',
      //   '新竹臺大',
      //   '羅東博愛',
      //   '羅東聖母',
      //   '陽大附醫',
      // ],
    };

    const middle = {
      promote: ['中國附醫', '中山附醫', '台中榮總', '彰基醫院'],
      collaborate1: ['大甲光田', '沙鹿光田', '部立豐原', '臺中慈濟', '中港澄清', '部立台中', '林新醫院'],

      collaborate2: ['童綜合醫院', '彰化秀傳', '彰濱秀傳', '南投佑民醫院', '雲林若瑟', '雲林臺大'],
    };

    const south = {
      promote: [
        '成大附醫',
        '台南奇美',
        '台南新樓',
        '台南郭綜合',
        '嘉基醫院',
        '高雄榮總',
        '高雄長庚',
        '高醫附醫',
        '義大醫院',
      ],
      collaborate: ['大林慈濟', '嘉義長庚', '聖馬爾定', '國軍高雄', '屏基醫院'],
    };

    const east = {
      promote: [],
      collaborate: ['花蓮慈濟', '花蓮門諾', '臺東基督教', '臺東馬偕'],
    };

    return {
      north,
      middle,
      south,
      east,
    };
  },
});
</script>
<style lang="scss" scoped>
.arrow {
  width: 50px;
  margin: 0 auto;
  background-color: transparent;

  img {
    width: 100%;
    transform: rotate(90deg);
  }
}

.promote {
  margin-top: 50px;
}

.tracking-team {
  background-color: rgba($c-assist-purple2, 0.3);
  @include padding(30px 22px);
  border-radius: 20px;

  &__title {
    @include font-style($c-main, 16, 500);
  }

  &__content {
    margin-top: 30px;
    @include font-normal();
  }
}

.promote-arrow {
  @include flex(center);
  margin: 30px 0 44px;

  &__box {
    transform: scaleY(-1);
    background-color: $c-main-yellow;
    position: relative;
    display: inline-block;
    width: 32px;
    @include padding(10px 0 3px);
    text-align: center;

    &::before {
      content: '';
      width: 0;
      height: 0;
      border-left: 30px solid transparent;
      border-right: 30px solid transparent;
      border-top: 30px solid $c-main-yellow;
      @include position(tl, 75%, 50%);
      transform: translateX(-50%);
      z-index: -1;
    }

    &__text {
      transform: scaleY(-1);
      display: inline-block;
      width: 20px;
      @include font-style($c-main, 16, 500, normal, 20px);
    }
  }
}

.checking-service {
  background-color: rgba($c-assist-green2, 0.3);
  @include padding(30px 22px);
  border-radius: 20px;

  &__title {
    @include font-style($c-main, 16, 500);
  }

  &__content {
    margin-top: 30px;
    @include font-normal();
  }
}

.hospital-distribute {
  border-radius: 25px;
  // background-color: $c-assist-blue2;
  margin-top: 50px;
}

.unit-area-title {
  @include font-important();
  min-width: 280px;
  width: 100%;
  max-width: 335px;
  margin: 0 auto 20px;

  &--margin-top {
    margin-top: 50px;
  }
}

.unit {
  border-radius: 25px;
  @include padding(20px);
  // min-width: 280px;
  // width: 100%;
  max-width: 335px;
  margin: 0 auto;

  & + & {
    margin-top: 30px;
  }

  &--north {
    background-color: $c-north-bg;
  }

  &--middle {
    background-color: $c-middle-bg;
  }

  &--south {
    background-color: $c-south-bg;
  }

  &--east {
    background-color: $c-east-bg;
  }

  &__promote {
    border: 1px solid $c-assist-purple2;
    border-radius: 20px;
    overflow: hidden;

    &__title {
      background-color: $c-assist-purple2;
      @include font-style($c-white, 20, 500, 2px 28px);
      height: 54px;
      @include flex(center, center);
    }

    &__list {
      background-color: $c-assist-purple4;
      @include font-normal();
      @include padding(10px 0);
      @include flex(center);
      .extend & {
        align-items: start;
      }
    }
  }

  &__collaborate {
    border: 1px solid $c-assist-green2;
    border-radius: 20px;
    overflow: hidden;
    margin-top: 0px;

    &__title {
      background-color: $c-assist-green2;
      @include font-style($c-white, 20, 500, 2px 28px);
      height: 54px;
      @include flex(center, center);
    }

    &__list {
      background-color: $c-assist-green3;
      @include font-normal();
      @include padding(10px 30px);
      @include flex(flex-start, flex-start);
      // flex: wrap;
    }
  }
}

.promote-list {
  margin: 0 auto;
}

.collaborate-list {
  // width: 100%;
  // @include inline-flex();
  // flex-wrap: wrap;
  width: auto;
  margin: 0 auto;

  &__item {
    flex: none;
    // width: 50%;
    // text-align: center;

    // &:nth-child(n) {
    //       width: 48%;

    //      }

    //      &:nth-child(2n) {
    //            width: 52%;

    //      }
  }
}

.taiwan {
  display: none;
}

@media screen and (min-width: $tablet) {
  .arrow {
    width: 50px;
    align-self: center;
    background-color: transparent;

    img {
      transform: rotate(0deg);
      width: 100%;
    }
  }

  .promote {
    @include flex();
  }

  .promote-arrow {
    @include flex(center);
    margin: 0 100px 0 85px;

    &__box {
      transform: scaleX(-1);
      background-color: $c-main-yellow;
      position: relative;
      display: inline-block;
      width: 45px;
      height: 32px;
      @include padding(0);
      @include flex(center);
      text-align: center;

      &::before {
        content: '';
        width: 0;
        height: 0;
        border-left: 30px solid $c-main-yellow;
        border-bottom: 30px solid transparent;
        border-top: 30px solid transparent;
        @include position(tl, 50%, 70%);
        transform: translateY(-50%);
        z-index: -1;
      }

      &__text {
        transform: scaleX(-1);
        display: inline-block;
        width: auto;
        @include font-style($c-main, 16, 500, normal, 20px);
      }
    }
  }

  .taiwan {
    display: block;
    width: 100%;
    text-align: center;

    &__img {
      display: inline-block;
      margin: 0 auto;
      position: relative;
      left: 100px;
    }
  }

  .hospital-distribute {
    position: relative;
    @include padding(400px 0 300px);
  }

  .unit-area-title {
    display: none;
  }

  .unit {
    min-width: auto;
    width: auto;
    max-width: 100%;
    @include flex(flex-start, flex-start);

    & + & {
      margin-top: 0px;
    }

    &--north {
      @include position(tl, 2%, 17%);
    }

    &--middle {
      @include position(tl, 36%, 0%);
    }

    &--south {
      @include position(tl, 60%, 9%);
    }

    &--east {
      @include position(tl, 60%, 63%);
    }

    &__promote {
      flex: none;
      width: 154px;
      &.extend {
        width: 260px;
      }
    }

    &__collaborate {
      flex: none;
      width: 320px;
      margin-top: 0px;
      // margin-right: 20px;

      &--pc {
        width: 180px;
      }

      &--no-margin {
        margin-right: 0;
      }
    }

    .collaborate-list {
      &__item {
        &--pc {
          width: 100%;
        }
      }
    }
  }
}
</style>
